import * as Sentry from '@sentry/browser';
import _get from 'lodash/get';
import {
  isLocalDev,
  getOneClickURL
} from '@common/components/branch-indicator/branch-indicator-utils';
import { getCookie } from '@util/cookies';
import { CLIENT_ID } from '@util/auth-token';
import packageJSON from '@package';

const isFromForeign = event =>
  /ckeditor\/|equedit|full-all|jquery|native code|anonymous|sdk|-extension|webxray|snake|calculator|mathlive|translate_|hidden|keyboardNavigation|unknown|undefined|gtag|kickass/i.test(
    _get(_get(event, 'exception.values.0.stacktrace.frames', []).slice(-1), '0.filename')
  );

const shouldIgnoreException = event =>
  /Token API|Not Authenticated|infinite loop|e\.apply is not a function|ceCurrentVideo\.currentTime|status code [3-5]0|NetworkError when attempting to fetch|Failed to fetch|Blocked a frame with origin|CustomEvent|network connection was lost|CKEDITOR\.resourceManager|Invalid flags supplied to RegExp|The operation was aborted|The network connection was lost|Software caused connection abort|Non-Error promise|no supported source|cross origin|Sandbox access violation|SecurityError|AbortError|setTextEditMode|ResizeObserver|'setStart'|'setEnd'|cancelled|NumberFormatException|connection appears to be offline|adb_rotate|Nothing was returned from render|Use before declaration|Loading chunk|msoCommentHide|msoCommentShow|Preflight response|La conexión|readyState|webkitEnterFullscreen|target\.className\.indexOf is not a function|la operación|HierarchyRequestError|\.ru\|timed out|SSL error|cancelado|Load failed|Unexpected token|tryLogin|internal error|operation is not supported|hover|insertBefore|Right side of assignment|getComputedStyle|end of JSON|expected pattern|cannot parse response|prayer|unexpected end of data|globalThis|more_menu|No row with id|a\.[LK]|illegal invocation|pagespeed|variable: gmo|operaration is insecure/i.test(
    _get(event, 'exception.values.0.value')
  );

const addOneClick = event => {
  if (event.user) {
    const isOnlineTesting = /\/onlinetestingapi\/onlinetesting/i.test(
      window.top.location.pathname
    );
    const testCreatorEmail = isOnlineTesting && event.contexts?.testInfo?.creatorEmail;

    // eslint-disable-next-line
    event.user.oneclick = getOneClickURL({
      username: testCreatorEmail || event.user.username,
      organizationId: event.user.organizationId,
      branchName: getCookie('FrontEndBranchName'),
      pathName:
        testCreatorEmail &&
        `/awarev2/assessments/author/edit/${event.contexts.testInfo.testId}`
    });
  }
  return event;
};

Sentry.init({
  dsn: 'https://eb20356129ea49048db0994bd268f15e@sentry.io/205101',
  release: `frontend@${packageJSON.version}`,
  environment: process.env.NODE_ENV,
  initialScope: {
    tags: { clientid: CLIENT_ID }
  },
  beforeSend(event /* , hint */) {
    return isLocalDev() || isFromForeign(event) || shouldIgnoreException(event)
      ? null
      : addOneClick(event);
  }
});

const logToConsole = (message, ex) =>
  window.console && console.error && console.error(message, ex); // eslint-disable-line

const logException = (ex, context) => {
  let eventId = '';

  Sentry.withScope(scope => {
    scope.setExtra('context', context);
    Sentry.captureException(ex);
    eventId = Sentry.lastEventId();
  });

  logToConsole('error in sentry', ex);

  if (context) {
    logToConsole('context', context);
  }

  return eventId;
};

export default logException;
